export async function GetPlanHistoryApi(planId, filters = {}) {
  try {
    const token = 'Bearer ' + localStorage.getItem('authToken');
    const queryParams = new URLSearchParams();
    
    if (filters.actionType) queryParams.append('actionType', filters.actionType);
    if (filters.actionBy) queryParams.append('actionBy', filters.actionBy);
    if (filters.startDate) queryParams.append('fromDate', filters.startDate);
    if (filters.endDate) queryParams.append('toDate', filters.endDate);
    
    const url = `${process.env.REACT_APP_API_URL}v1/plan-history/plan/${planId}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    });

    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('HTTP Error Response:', errorText);
      return { success: false, message: `HTTP ${response.status}: ${errorText}` };
    }
    
    const data = await response.json();
    
    return data;
  } catch (error) {
    console.error('Error fetching plan history:', error);
    return { success: false, message: 'Failed to fetch plan history' };
  }
}
